import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { catchError, of } from 'rxjs';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { ModelDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/model-dto';
import { StamdataStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/stamdata-status-enum';
import { CreateModellerRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/create-modeller-request';
import { ModelService } from 'src/app/api/services';
import { EditModelDialogData } from 'src/app/components/aftale/models';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { StamdataStatusService } from '../../shared/stamdata-status.service';
import { StamdatastatusModel } from '../../shared/stamdatastatus.model';

@Component({
    selector: 'app-model-edit-dialog',
    templateUrl: './model-edit-dialog.component.html',
    styleUrls: ['./model-edit-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModelEditDialogComponent implements OnInit {
  model: ModelDto;
  form: UntypedFormGroup;
  fabrikater: FabrikatDto[] = [];
  selectedFabrikat: FabrikatDto;
  modelstatusser: Array<StamdatastatusModel> = [];

  get name() {
    return this.form.get('name');
  }

  get names() {
    return this.form.get('names');
  }

  get fabrikat() {
    return this.form.get('fabrikat');
  }

  get modelstatus() {
    return this.form.get('modelstatus');
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: ModelService,
    private statusservice: StamdataStatusService,
    private notification: NotificationService,
    private errorHandler: ErrorHandlerService,
    public dialogRef: MatDialogRef<ModelEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditModelDialogData
  ) {
    this.model = data.model;
    this.fabrikater = data.fabrikater;
    this.selectedFabrikat = data.fabrikat;
  }

  ngOnInit(): void {
    this.modelstatusser = this.EnumToArray(StamdataStatusEnum).map((p) => {
      return { value: p, name: this.statusservice.stamdatastatus(p) };
    });

    this.form = this.formBuilder.group({
      fabrikat: [this.selectedFabrikat?.id, [Validators.required]],
      name: [this.model?.name, []],
      modelstatus: [this.model?.modelstatus, [Validators.required]],
      names: [null, []],
    });

    this.names.clearValidators();
    this.name.clearValidators();
    if (this.model) {
      this.name.setValidators(Validators.required);
      this.name.setValidators(Validators.minLength(3));
      this.names.setValue(null);
    } else {
      this.names.setValidators(Validators.required);
      this.names.setValidators(Validators.minLength(3));
      this.name.setValue(null);
    }

    this.names.updateValueAndValidity();
    this.name.updateValueAndValidity();
  }

  async update() {
    if (!this.form.valid) return;

    const fabrikat = this.fabrikater.find((x) => x.id == this.form.get('fabrikat').value);

    let data: ModelDto = Object.assign({}, this.model, this.form.value);
    data.fabrikat = fabrikat;

    let result: FabrikatDto = null;

    let successText = '';

    if (this.model?.id) {
      result = await this.service
        .updateModel({
          modelId: this.model.id,
          caller: EGIS_SERVICE_CALLER,
          body: data,
        })
        .toPromise();
      successText = 'Modellen er opdateret';
    } else {
      const navne = this.names.value
        .replace(/\r\n/g, '\n')
        .split('\n')
        .filter((line) => line);
      const req: CreateModellerRequest = {
        names: navne,
        fabrikatId: this.fabrikat.value,
        modelstatus: this.modelstatus.value,
      };
      result = await this.service
        .createModeller({ caller: EGIS_SERVICE_CALLER, body: req })
        .pipe(
          catchError((error) => {
            this.errorHandler.HandleError(error);
            return of(null);
          })
        )
        .toPromise();
      successText = navne.length > 1 ? 'Modellerne er gemt.' : 'Modellen er gemt.';
    }
    const modelText = this.notification.success(successText);
    this.dialogRef.close(result);
  }

  EnumToArray(enumme) {
    return Object.keys(enumme).map((key) => enumme[key]);
  }
}
